// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import Button, { ButtonPresentationProps, ButtonProps } from "@insite/mobius/Button";
import { addToCartStatus, AddToCartStatusInfoInterface } from "@steiner/XDL/constants";
import React, { useState } from "react";

interface OwnProps {
    currentStatus?: AddToCartStatusInfoInterface;
    setCurrentStatus?: (state: AddToCartStatusInfoInterface) => void;
    iconConfig?: IconConfig;
    disabled?: boolean;
    extendedStyles?: ButtonPresentationProps;
}

export interface IconConfig {
    src: React.ComponentType | string;
    position: "right" | "left";
}

type Props = OwnProps & ButtonProps;

export const addToCartButtonStyles: ButtonPresentationProps = {};

const AddToCartButton = ({
    currentStatus,
    setCurrentStatus,
    children,
    extendedStyles,
    disabled,
    iconConfig,
    ...otherProps
}: Props) => {
    const [styles] = useState(() => mergeToNew(addToCartButtonStyles, extendedStyles));

    React.useEffect(() => {
        if (currentStatus === addToCartStatus.success) {
            setTimeout(() => {
                setCurrentStatus?.(addToCartStatus.default);
            }, 1000);
        }
    }, [currentStatus]);

    if (disabled) {
        return (
            <Button {...styles} icon={iconConfig} {...otherProps} disabled={true}>
                {children}
            </Button>
        );
    }

    return (
        <Button {...styles} icon={iconConfig} {...otherProps}>
            {children}
        </Button>
    );
};
export default AddToCartButton;
